export default __webpack_public_path__ + "static/media/empty-search.5506a9c1.svg";